import { useEffect, useRef, useState } from "react";
import CatService from "../../../service/CatService";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import CmsService from "../../../service/CmsService";
import { ButtonMenu } from "../../common/ButtonMenu";
import { CrsIcon } from "../../common/Icons";
import { TabPanel, TabView } from "primereact/tabview";
import { TempGrid } from "../temp/TempGrid";
import { CrtGrid } from "../crt/CrtGrid";
import { useTranslation } from "react-i18next";
import { Messages } from "primereact/messages";
import { PermDialog } from "../../common/PermGrid";
import CatTreeSelect from "../../cat/CatTreeSelect";
import { DataTable } from "primereact/datatable";
import "../../common/DataTableHover.css";

export function QueBank(props){
    let navigate = useNavigate();     
    const messages = useRef(null);  
    const [crss,setCrss]=useState([]);
    const [permDialog,setPermDialog]=useState(false);
    const [selectedCourse,setSelectedCourse]=useState(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const [noRoot,setNoRoot]=useState(false);

    const {t} = useTranslation();

    const addMenuItems=(node)=>{return [
        {label: t('QuestionType.MC'),command:()=>openAddQuestionPage(node.id,'MC')},
        {label: t('QuestionType.MR'),command:()=>openAddQuestionPage(node.id,'MR')},
        {label: t('QuestionType.TF'),command:()=>openAddQuestionPage(node.id,'TF')},
        {label: t('QuestionType.YN'),command:()=>openAddQuestionPage(node.id,'YN')},
        {label: t('QuestionType.OE'),command:()=>openAddQuestionPage(node.id,'OE')},
        {label: t('QuestionType.FIB'),command:()=>openAddQuestionPage(node.id,'FIB')},
        {label: t('QuestionType.MATCH'),command:()=>openAddQuestionPage(node.id,'MATCH')},
        {label: t('QuestionType.GRP'),command:()=>openAddQuestionPage(node.id,'GRP')}, 
        {label: t('QuestionType.INT'),command:()=>openAddQuestionPage(node.id,'INT')},        
    ]};
    const importMenuItems=(node)=>{return [
        {label: t('From Documents (RTF,ODT)'),command:()=>openImportQuestionPage(node.id,'doc')},
        {label: t('From Image (PDF, JPG)'),command:()=>openImportQuestionPage(node.id,'image')}
    ]};

	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t("@error."+err)});
	}	

    const hasPerm=(node,perm)=>{
        if(!node.perms)
            return false;
        if(node.perms.includes("*"))
            return true;
        if(node.perms.includes(perm))
            return true;
        if(node.childPerms.includes(perm))
            return true;
        return false;
    }
    const actionButtons=(node)=>{
        let addEnabled=hasPerm(node,'cms:que:author');
        let viewEnabled=hasPerm(node,'cms:que:view');
        let permEnabled=hasPerm(node,'cms:admin');
        return(<div className="p-1 flex flex-row gap-2">
            <ButtonMenu outlined icon="pi pi-plus" label={t('Add')} items={addMenuItems(node)} disabled={!addEnabled}></ButtonMenu>
            <Button icon="pi pi-search" outlined label={t('Search')} disabled={!viewEnabled} onClick={()=>openSearchQuestionPage(node.id)}></Button>
            <ButtonMenu icon="pi pi-file-import" outlined label={t('Import')} items={importMenuItems(node)} disabled={!addEnabled}></ButtonMenu>
            <Button outlined label={t('Perms')} icon="pi pi-key" disabled={!permEnabled} onClick={()=>openPermDialog(node)}></Button>
        </div>)
    }
    const openAddQuestionPage=(catId,qType)=>{
        if(qType=='GRP')
            navigate('/itembank/addgrp/'+catId);          
        else    
            navigate('/itembank/add/'+catId+"?questionType="+qType);
    }
    const openSearchQuestionPage=(catId)=>{
        navigate('/itembank/cats/'+catId+'/questions');
    }
    const openImportQuestionPage=(catId,docType)=>{
        navigate('/itembank/cats/'+catId+'/questions/load?docType='+docType);
    }

    const actionTemplate=(node)=>{
        //if(node.key!=selectedNodeKey)
        //    return <></>
        return actionButtons(node);
    }
    const onPermDialogClose=()=>{setPermDialog(false)}
    const openPermDialog=(course)=>{
        setSelectedCourse(course);
        setPermDialog(true);
    }
    const checkRoots=()=>{
        CatService.getCats().then((ret)=>{
            if(ret.length==0)
                setNoRoot(true);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
    const onRootSelect=(root)=>{
        CmsService.getBankCourses(root.id).then((ret)=>{
            setCrss(ret);            
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
    const rowExpansionTemplate=(data)=>{
        return (
            <div className="m-4">
            <h5>{data.name} [{data.code}]</h5>
            {actionTemplate(data)}
            </div>)
    }
    const onRowExpand=(e)=>{
        let er=[e.data];
        setExpandedRows(er);
    }
    const onRowClick=(e)=>{
        onRowExpand(e);
    }
    const onRowCollapse=(e)=>{
        setExpandedRows(null);
    }
    useEffect(()=>{
        checkRoots();
    },[]);
    return(
        <>
            {!noRoot?
            <div className="card col-12 xl:col-8">
                <TabView>
                <TabPanel header={t('Questions')}>
                    <div className="flex flex-column gap-2">
                        <Messages ref={messages}></Messages>
                        <CatTreeSelect parentId={0} value={0} onSelect={onRootSelect} catType="ROOT" placeholder={t('Select_a_group')}/>
                        <DataTable dataKey="id" value={crss} showGridlines tableStyle={{ minWidth: '50rem' }}
                            rowExpansionTemplate={rowExpansionTemplate} expandedRows={expandedRows} selectionMode="single"
                            onRowExpand={onRowExpand} onRowCollapse={onRowCollapse} onRowClick={onRowClick}>
                            <Column expander="true" style={{ width: '5rem' }} />
                            <Column field="name" header={t('Name')} style={{width:'60%'}}></Column>
                            <Column field="itemCount" header={t('# Items')} style={{width:'40%'}}></Column>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header={t('Print Templates')}>
                    <TempGrid></TempGrid>
                </TabPanel>
                <TabPanel header={t('Test Templates')}>
                    <CrtGrid></CrtGrid>
                </TabPanel>
                </TabView>
            </div>   
            :
            <div className="card col-12 xl:col-8">
                <h5>{t('No_curriculum_found_setup_curriculum_first')}</h5>
                <Button label={t("Open_Curriculum")} className='mt-2' onClick={()=>navigate('/curriculum')} severity='secondary'/> 
            </div> 
            }   
			{
				permDialog?
				<PermDialog visible={permDialog} objId={selectedCourse.id} objType={'CAT'} 
					objName={selectedCourse.name} onClose={onPermDialogClose} onHide={onPermDialogClose}></PermDialog>:<></>
			}

        </>
    )
}